






















































































































import Vue from "vue";
import WordMatrix from "./WordMatrix";
export default WordMatrix;
